<!--
 * @Author: DouDou
 * @LastEditors: 豆豆
 * @Date: 2020-09-11 12:16:44
 * @LastEditTime: 2020-11-07 18:30:03
 * @Description: File description
-->
<template>
  <div class="rewardPage">
    <!-- <div class="rewardPage-notice-bar" v-if="pageNotice">
      <van-notice-bar mode="closeable" left-icon="volume-o"
        background="#fff5e0" color="#FE9B43" :text="pageNotice"
        @close="pageNotice=false"
      />
    </div> -->
    <!-- End: 通知栏-跑马灯 -->
    <div class="rewardPage-reward-myown">
      <div class="rewardPage-card-title">
          <i class="icon icon-gift"></i>
          <b>我的奖励</b>
      </div>
      <div class="rewardPage-card-content">
        <div class="rewardPage-card-item" :class="{'link' : item.description === '兑换课程' || item.description === '礼品卡'}" v-for="(item,index) in reward_money_all" :key="index" @click="handleRewardClick(item)"
        >
          <div class="rewardPage-card-item-con"><output>{{ item.dataNum || 0 }}</output> {{item.dataUnit || '元'}}</div>
          <p class="rewardPage-card-item-des">{{item.description || '累计获得奖励'}}
            {{item.description === '兑换课程' ? ' >' :''}}
            {{item.description === '礼品卡' ? ' >' :''}}
          </p>
        </div>
      </div>
      <div class="rewardPage-card-title">
        <i class="icon icon-wallet"></i>
        <p>可提现</p>
        <i class="icon icon-wenhao" @click="discountToastShow"></i>
        <span class="right" @click="go2NewSucessList()">提现记录 ></span>
      </div>
      <div class="rewardPage-card-cash">
        <div :class="obtainNum > 0 ? 'rewardPage-withdraw-count' : 'rewardPage-withdraw-count-empty'">
          <span><output>{{ obtainNum }}</output> 元</span>
          <span class="rewardPage-withdraw-count-btn" @click="depositMoney()">提现</span>
        </div>
        <div class="rewardPage-withdraw-tip">
          <span>小贴士：</span>
          <p>
            ①好友结课后学费才计入“可提现” <br>
            ②可提现金额不超过您在网校消费的总金额
          </p>
        </div>
      </div>
    </div>
    <!-- End: 我的奖励 -->
    <div class="rewardPage-reward-recomment">
      <div class="rewardPage-module-header">
        <div>邀请奖励</div>
      </div>
      <div class="rewardPage-module-main">
        <div class="rewardPage-module-summary">
          <div v-for="(item,index) in reward_recommend_all" :key="index">
            <div><output>{{item.dataNum || 0}}</output>{{item.dataUnit || '人'}}</div>
            <p>{{item.description || ''}}</p>
          </div>
        </div>
        <div v-show="isRecommendUnfold" class="rewardPage-module-content">
          <div v-if="recommendData.length" class="rewardPage-module-list">
            <div class="rewardPage-module-item"
              v-for="(item, index) in recommendData" :key="index"
            >
              <div class="rewardPage-reward-recomment-user">{{item.inviteName}}</div>
              <div v-if="item.progressBlock.length" class="rewardPage-reward-recomment-items">
                <div v-for="(v, i) in item.progressBlock" :key="i"
                  :class="`rewardPage-reward-recomment-item-${v.lightUp == 1 ? 'activated' : 'gray'}`"
                >
                  <div>{{v.title}}</div>
                  <h5>{{v.createTime}}</h5>
                  <p>{{v.description || ''}}</p>
                </div>
              </div>
            </div>
            <div class="rewardPage-module-loadmore">
              <span v-if="recommendLastpage !== 'no' && recommendData.length >= 8"
                class="showlangdata"
                @click="getRecommendPageinfo"
              >点击加载更多</span>
              <span class="nothingdata" v-else>- 没有更多了 -</span>
            </div>
          </div>
          <div v-else class="rewardPage-module-none">
            <p>- 暂无记录 -</p>
            <!-- <div @click="go2PosterSave()">立即邀请</div> -->
          </div>
        </div>
        <div class="rewardPage-module-btn">
          <span @click="isRecommendUnfold = !isRecommendUnfold">
            {{isRecommendUnfold ? '收起': '展开'}}
            <i :class="['icon', `icon-arrow-${isRecommendUnfold ? 'top': 'bottom'}`]"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- End: 推荐奖励 -->

    <div v-if="isShowWelfare" class="rewardPage-reward-extra">
      <div class="rewardPage-module-header">
        <div>特别奖励</div>
      </div>
      <div class="rewardPage-module-main">
        <div class="rewardPage-module-summary">
          <div class="rewardPage-module-summary">
            <div v-for="(item,index) in reward_extra_all" :key="index">
              <div><output>{{item.dataNum || 0}}</output>{{item.dataUnit || '人'}}</div>
              <p>{{item.description || ''}}</p>
            </div>
          </div>
        </div>
        <div v-show="isWelfareUnfold" class="rewardPage-module-content">
          <!-- <div v-if="welfareData.length" class="invitation-module-list"> -->
          <div v-if="welfareData" class="rewardPage-module-list">
            <div class="rewardPage-module-item"
              v-for="(item, index) in welfareData" :key="index"
            >
              <div>{{item.createTime}}</div>
              <div>{{item.billMark}}</div>
              <div>{{item.Remark}}</div>
            </div>
            <div class="rewardPage-module-loadmore">
              <span v-if="this.welfareLastpage !== 'no' && welfareData.length >= 8"
                class="showlangdata" @click="getwelfarePageinfo"
              >点击加载更多</span>
              <span class="nothingdata" v-else>- 没有更多了 -</span>
            </div>
          </div>
          <div v-else class="rewardPage-module-none">
            <p>- 暂无记录 -</p>
          </div>
        </div>
        <div :class="['rewardPage-module-btn']">
          <span @click="isWelfareUnfold = !isWelfareUnfold">
            {{isWelfareUnfold ? '收起': '展开'}}
            <i :class="['icon', `icon-arrow-${isWelfareUnfold ? 'top': 'bottom'}`]"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- End: 特别奖励 -->

    <div class="withDraw-details">
      <!-- 可提现规则弹框 -->
      <van-popup v-model="discountShow" class="x-van-popup rewardPage-popup">
        <div class="rewardPage-popup-close" @click="discountToastClose"></div>
        <div class="rewardPage-popup-title">可提现说明</div>
        <div class="rewardPage-popup-content">
          <div class="withDraw-dialog__bd">
            <ul class="withDraw-explain">
              <li><i>1、好友正常结课后，现金奖励才会计入可提现金额。</i></li>
              <li
                class="withDraw-note-txt"
              >例：当前您的累计获得学费为100元，可提现金额为0元；需等待受邀好友结课后，这100元将计入可提现金额。</li>
              <!-- <li>2、受提现上限限制，您可能无法全部取出奖励学费，请参考以下提现上限：</li> -->
              <li>
                <i>2、可提现金额不得超过您的消费总金额。（不含未结课课程）</i>
              </li>
              <li class="withDraw-note-txt">例：您累计获得学费1000元，但您在网校的历史累计消费金额为500元，那么您最多可提现500元。</li>
              <li><i>3、剩余累计学费可在您继续消费后提现。（结课后可提现）</i></li>
              <li class="withDraw-note-txt">例：您累计获得1000元，但由于累计消费500元，所以可提现500元。当您继续在网校消费500元后，剩余的500元可在您结课后提现。</li>
            </ul>
          </div>
        </div>
      </van-popup>
      <!-- 提现过程弹出框 -->
      <van-popup v-model="withDrawDialog">
        <!-- 已绑定账号和身份证号，可提现弹框  -->
        <div
          class="details-dialog-con withDraw-idCard-dialog"
          v-if="isWxFocus && userCash.authIdentity === 1"
        >
          <div class="withDraw-idCard-dialog__hd">
            <i class="close" @click="withDrawDialog = false"></i>
            <h2 class="withDraw-idCard-dialog__nav details-dialog__navnew">
              <i>{{obtainNum}}</i>元
            </h2>
          </div>
          <div class="withDraw-idCard-dialog__bd">
            <div class="withDraw-idCard-dialog__cell">
              <div class="withDraw-idCard-dialog__nickname">
                <h4>安全认证提示</h4>
                <h3>微信账号昵称 ：{{userCash.nickname}}</h3>
                <h3>已提现的姓名 ：{{userCash.realname}}</h3>
              </div>
              <div class="withDraw-idCard-imgBox">
                <img :src="userCash.headimgurl" alt />
              </div>
            </div>
            <p class="withDraw-idCard-dialog__statement">
              *提现金额将进入该微信账号对应的微信零钱包，请确保已绑定正确的微信账号，如需
              <i>更换账号</i>，
              请前往“
              <i>学而思网校</i>”官方公众号回复“
              <i>返学费</i>”
            </p>
          </div>
          <div class="withDraw-idCard-dialog__ft">
            <button
              class="btn"
              :class=" againDrawText === '提现中...' && 'drawing' "
              @click="againDrawMoney"
            >{{againDrawText}}</button>
            <button class="btn withDraw-idCard-dialog__opcity" @click="changeDrawMoney">重新输入实名信息</button>
            <p>
              如有问题可联系客服：
              <a href="tel:400-800-2211">400-800-2211</a>
            </p>
          </div>
        </div>
        <!-- 已绑定账号,但未绑定身份证号，可提现弹框 -->
        <div
          class="details-dialog-con withDraw-idCard-dialog"
          v-if="isWxFocus && userCash.authIdentity !== 1"
        >
          <div class="withDraw-idCard-dialog__hd">
            <i class="close" @click="withDrawDialog = false"></i>
            <h2 class="withDraw-idCard-dialog__nav">
              <i>{{obtainNum}}</i>元
            </h2>
          </div>
          <div class="withDraw-idCard-dialog__bd">
            <ul class="withDraw-idCard-dialog__list">
              <li>
                <h2>
                  <i>验证微信真实姓名</i>
                </h2>
                <div class="withDraw-idCard-dialog__nickname">
                  <h3 class="withDraw-idCard-headPadding">微信账号昵称 ：{{userCash.nickname}}</h3>
                  <div class="withDraw-idCard-imgBox">
                    <img :src="userCash.headimgurl" alt />
                  </div>
                </div>
                <input class="withDraw-idCard-input" placeholder="请输入该微信账号对应的真实姓名" v-model="realname" />
                <p>
                  *提现金额将进入该微信账号对应的微信零钱包，请确保已绑定正确的微信账号，如需
                  <i>更换账号</i>，
                  请前往“
                  <i>学而思网校</i>”官方公众号回复“
                  <i>返学费</i>”
                </p>
              </li>
              <li>
                <h2 class="showcarid">
                  <i>验证身份证号</i>
                </h2>
                <input
                  class="withDraw-idCard-input"
                  placeholder="请输入微信实名对应的身份证号"
                  @change="cardChange"
                  maxlength="18"
                  v-model="cardId"
                />
                <p>*身份证信息将用于进行个税申报，网校将承担您所获奖金的个税。我们不会以任何形式泄漏您的个人信息。</p>
              </li>
            </ul>
          </div>
          <div class="withDraw-idCard-dialog__ft">
            <button
              class="btn"
              :class=" drawText === '提现中...' && 'drawing' "
              @click="drawMoney"
            >{{drawText}}</button>
            <p>
              如有问题可联系客服：
              <a href="tel:400-800-2211">400-800-22112</a>
            </p>
          </div>
        </div>
        <!-- 未绑定账号，不可提现弹框 -->
        <div class="withDraw-idCard-dialog-conne" v-if="!isWxFocus">
          <div class="withDraw-idCard-dialog-close" @click="withDrawDialog = false"></div>
          <div class="withDraw-idCard-dialog__ft" @click="goWithdraw">
            <!-- <button class="btn" @click="goWithdraw">一分钟了解流程</button> -->
          </div>
        </div>
      </van-popup>
      <!-- 输入姓名与微信账号实名不一致 -->
      <van-popup v-model="realShow">
        <div class="details-dialog-con withDraw-idCard-dialog withDraw-idCard-realSure">
          <div class="withDraw-idCard-dialog__hd">
            <i class="close" @click="realShow = false"></i>
            <h2 class="withDraw-idCard-dialog__nav">
              <i>{{obtainNum}}</i>元
            </h2>
          </div>
          <div class="withDraw-idCard-dialog__bd">
            <p class="withDraw-idCard-realSure__title">您所输入的姓名和该微信账号对应的实名不一致。</p>
          </div>
          <div class="withDraw-idCard-dialog__ft">
            <button
              class="btn"
              :class=" continueDrawText === '提现中...' && 'drawing' "
              @click="continueDrawMoney"
            >{{continueDrawText}}</button>
            <button class="btn withDraw-idCard-dialog__opcity" @click="changeDrawMoney">重新输入实名信息</button>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- End: 礼品卡介绍弹窗 -->
    <login-handle ref="loginHandle" />
    <!-- End: 未登录登录处理。 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoginHandle from '../components/LoginHandle'

export default {
  naem: 'rewardPage',
  components: { LoginHandle },
  data () {
    return {
      device: '', // 区分设备
      cardId: '', // 身份证号
      tutorId: '', // 辅导老师id
      realname: '', // 真实姓名
      userCash: {}, // 用户绑定的微信昵称
      obtainNum: 0, // 可提现金额
      welfareNum: 0, // 特别福利分页数
      welfareSize: 0, // 特别福利梅特条数
      pageNotice: '', // 页面通告：走马灯
      welfareData: [], // 推荐有奖展示数据
      realShow: false, // 输入姓名与微信账号实名不一致弹框
      recommendNum: 0, // 推荐有奖分页数
      recommendSize: 0, // 推荐有奖每页条数
      isSending: false, // 接口是否正在发送
      isWxFocus: false, // 是否已经关注了微信公众号
      recommendData: [], // 推荐有奖展示数据
      discountShow: false, // 可提现说明弹框
      drawText: '确认提现', // 提现弹窗按钮文案
      isShowWelfare: false, // 特殊奖励是否展示
      withDrawDialog: false, // 是否显示提现弹窗
      welfareLastpage: 'no',
      isWelfareUnfold: false, // 特殊奖励是否折叠
      isRecommendUnfold: true, // 推荐奖励是否折叠
      recommendLastpage: ' no', // 是否为左后一页
      againDrawText: '继续使用该账号提现',
      continueDrawText: '继续使用该账号提现',
      isApp: /.*jzh$/.test(navigator.userAgent),
      pageData: { base: {}, banner: {}, extra: {} } // 获取页面总数据

    }
  },
  computed: {
    ...mapState(['userInfo']),
    // 我的奖励数据
    reward_money_all () {
      const { dataBlock } = this.pageData.banner
      const emptyData = [
        { dataNum: '--', dataUnit: '元', description: '现金' },
        { dataNum: '--', dataUnit: '元', description: '礼品卡' },
        { dataNum: '--', dataUnit: '个', description: '金币' },
        { dataNum: '--', dataUnit: '节', description: '兑换课程' }
      ]
      return Array.isArray(dataBlock) ? dataBlock.filter(v => v.description !== '可提现') : emptyData
    },
    // 邀请奖励数据
    reward_recommend_all () {
      const { card } = this.pageData.base
      const emptyData = [
        { dataNum: 0, dataUnit: '人', description: '已注册' },
        { dataNum: 0, dataUnit: '人', description: '已购课' },
        { dataNum: 0, dataUnit: '人', description: '已结课' }
      ]
      return (card && card.dataBlock) ? card.dataBlock.filter(v => v.description !== '可提现') : emptyData
    },
    // 特别奖励数据
    reward_extra_all () {
      const { card } = this.pageData.extra
      const emptyData = [
        { dataNum: 0, dataUnit: '个', description: '参与活动' },
        { dataNum: 0, dataUnit: '次', description: '完成次数' }
      ]
      return (card && card.dataBlock) ? card.dataBlock.filter(v => v.description !== '可提现') : emptyData
    }
  },
  async created () {
    const { tutorId } = this.$route.query
    this.tutorId = tutorId || ''
    this.$toast.loading({ message: '加载中...', duration: 0 })
    await this.getPageData()
    this.getPageNotice()
    this.checkUserCash() // 提现信息
    const ua = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(ua)) { // 苹果设备
      this.device = 'iphone'
    } else if (/android/.test(ua)) { // 安卓设备
      this.device = 'android'
    } else { // web端
      this.device = 'web'
    }
  },
  methods: {
    // 获取页面数据
    getPageData () {
      return this.$api.getRewardPageinfo().then(res => {
        this.$toast.clear()
        const { code, data } = res
        if (code !== 0) return this.$refs.loginHandle.callLogin()
        if (res.stat === 1) {
          this.pageData = data.acuserdetail
          // banner: 我的奖励 。base：推荐奖励。 extra：额外奖励
          const { banner = {}, base = {}, extra } = data.acuserdetail
          // 可提现金额
          const withDraw = banner.dataBlock.filter(v => v.description === '可提现')[0]
          this.obtainNum = withDraw ? withDraw.dataNum : 0
          /* # 1 推荐有奖数据 */
          if (base.card.list) {
            this.recommendData = base.card.list.data ? base.card.list.data : []
            if (base.card.list.page) {
              // 推荐有奖 当前页
              this.recommendNum = base.card.list.page.pageNum
              // 推荐有奖 每页条数
              this.recommendSize = base.card.list.page.pageSize
              this.recommendLastpage = base.card.list.page
            } else {
              this.recommendLastpage = 'no'
            }
          }
          /* # 2 特别福利 */
          if (!extra) return
          this.isShowWelfare = true
          if (extra.card.list) {
            this.welfareData = extra.card.list.data ? extra.card.list.data : []
            if (extra.card.list.page) {
              // 特别福利 当前页
              this.welfareNum = extra.card.list.page.pageNum
              // 特别福利 每页条数
              this.welfareSize = extra.card.list.page.pageSize
              this.welfareLastpage = extra.card.list.page
            } else {
              this.welfareLastpage = 'no'
            }
          }
        }
      })
    },
    // 获取公告
    getPageNotice () {
      this.$api.getmeginfo().then(res => {
        this.pageNotice = res.data.noticeMsg[0]
      })
    },
    // 获取用户是否有提现权限以及
    checkUserCash () {
      // 校验用户提现信息
      this.$api.checkUserCash().then(res => {
        if (res.code === 0) {
          this.isWxFocus = true
          this.userCash = res.data
        } else {
          this.isWxFocus = false
        }
      })
    },
    // 我的奖励面板点击
    handleRewardClick (reward) {
      if (reward.description === '礼品卡') return this.go2GiftCard()
      if (reward.description === '兑换课程') return this.go2CoureseExchange()
      this.$xesLogger.clickMsg({ params: { action: 'handleRewardClick', clickid: '3.2.9', btn: reward.description } })
    },
    go2GiftCard () {
      this.$xesLogger.clickMsg({ params: { action: 'go2GiftCard', clickid: '3.3.1' } })
      // 通过通知信息（跑马灯）接口判断登录，未登录跳转登录
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      if (this.device === 'android' && this.isApp) {
        xesApp.start('http://app.xueersi.com/cardcouponh5/#/cardcoupon')
      } else {
        location.href = 'http://app.xueersi.com/cardcouponh5/#/cardcoupon'
      }
      console.log('挑战到礼品卡页面')
    },
    // 跳转课程兑换页面
    go2CoureseExchange () {
      this.$xesLogger.clickMsg({ params: { action: 'go2CoureseExchange', clickid: '3.2.2' } })
      // 通过通知信息（跑马灯）接口判断登录，未登录跳转登录
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      this.$router.push({ name: 'courseExchange' })
    },
    // 点击立即邀请，跳到海报制作页
    go2PosterSave () {
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: { action: 'gosavePoster', clickid: '5.7.4' }
      })
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      let route = { name: 'savePoster' }
      if (this.tutorId) { // 辅导老师老带新传递参数跳转
        route = { name: 'savePoster', query: { tutorId: this.tutorId } }
      }
      this.$router.push(route)
    },
    // 跳转提现记录
    go2NewSucessList () {
      this.$xesLogger.clickMsg({ params: { action: 'gonewSuccessList', clickid: '5.7.2.0' } })
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      this.$router.push({ name: 'withDrawRecord' })
    },
    // 提现按钮点击
    depositMoney () {
      this.$xesLogger.clickMsg({ params: { action: 'goDepositMoney', clickid: '5.7.2.1' } })
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      if (this.obtainNum === 0) {
        this.$toast({ message: '当前没有可提现的金额', duration: 1500 })
        return
      }
      this.$xesLogger.clickMsg({ params: { action: 'depositMoney', clickid: '5.1' } })
      this.withDrawDialog = true
    },
    // “邀请奖励”分页数据
    getRecommendPageinfo () {
      if (this.recommendLastpage === 'no') return
      this.$api.getRecommendPageinfo(this.recommendNum, this.recommendSize).then(res => {
        const resdata = res.data
        if (resdata.page) {
          this.recommendLastpage = resdata.page
        } else {
          this.recommendLastpage = 'no'
        }
        // eslint-disable-next-line
        this.recommendData.push.apply(this.recommendData, resdata.data)
        if (resdata.page) {
          this.recommendNum = resdata.page.pageNum
          this.recommendSize = resdata.page.pageSize
        }
      })
    },
    // ”特别福利“分页数据
    getwelfarePageinfo () {
      if (this.welfareLastpage === 'no') return
      this.$api.getWelfarePageinfo(this.welfareNum, this.welfareSize).then(res => {
        const resdata = res.data
        if (resdata.page) {
          this.welfareLastpage = resdata.page
        } else {
          this.welfareLastpage = 'no'
        }
        // eslint-disable-next-line
        this.welfareData.push.apply(this.welfareData, resdata.data)
        if (resdata.page) {
          this.welfareNum = resdata.page.pageNum
          this.welfareSize = resdata.page.pageSize
        }
      })
    },
    // 点击 确认提现 按钮
    drawMoney () {
      this.$xesLogger.clickMsg({ params: { action: 'drawMoney', clickid: '5.5' } })
      // 用户未绑定身份证号
      if (this.userCash.authIdentity !== 1) {
        const cardReg = /(^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)|(^[0-9a-zA-Z]{8}$)|(^[0-9a-zA-Z]{10}$)/
        if (this.realname === '') {
          this.$toast({
            message: '请输入该微信账号对应的真实姓名',
            duration: 1500
          })
          return
        }
        if (this.cardId === '') {
          this.$toast({
            message: '请输入微信实名对应的身份证号',
            duration: 1500
          })
          return
        }
        if (!cardReg.test(this.cardId)) {
          this.$toast({ message: '请输入正确格式的身份证号', duration: 1500 })
          return
        }
      }
      this.drawText = '提现中...'
      this.$api.userBonusCash(this.cardId, this.realname).then(res => {
        if (res.code === 0) { // 提现成功
          this.drawText = '提现成功'
          this.withDraw = false
          this.$emit('success')
          this.getPageData()
          this.$xesLogger.clickMsg({ elem: document.body, params: { action: 'drawMoney', clickid: '5.18' } })
        } else if (res.code === 2) { // 输入姓名与微信账号实名不一致
          this.realShow = true
          this.withDrawDialog = false
          this.drawText = '确认提现'
        } else { // 提现失败提示错误信息
          this.drawText = '确认提现'
          this.$toast({
            message: res.message,
            duration: 3000
          })
        }
      })
    },
    continueDrawMoney () {
      // 第一次用户提现验证姓名不一致强提
      this.$xesLogger.clickMsg({ elem: document.body, params: { action: 'continueDrawMoney', clickid: '5.6' } })
      this.continueDrawText = '提现中...'
      this.$api.userBonusCash(this.cardId, this.realname, 1).then(res => {
        this.continueDrawText = '继续使用该账号提现'
        if (res.code === 0) { // 提现成功
          this.realShow = false
          this.getPageData()
          this.$xesLogger.clickMsg({ elem: document.body, params: { action: 'continueDrawMoney', clickid: '5.20' } })
        } else { // 提现失败提示错误信息
          this.realShow = false
          this.$toast({
            message: res.message,
            duration: 1500
          })
        }
      })
    },
    againDrawMoney () {
      // 已有身份信息，第二次用户提现强提
      this.$xesLogger.clickMsg({ elem: document.body, params: { action: 'againDrawMoney', clickid: '5.7' } })
      this.againDrawText = '提现中...'
      this.$api.userBonusCash('', '', 1).then(res => {
        this.againDrawText = '继续使用该账号提现'
        if (res.code === 0) { // 提现成功
          this.againDrawText = '提现成功'
          this.withDrawDialog = false
          this.$emit('success')
          this.getPageData()
          this.$xesLogger.clickMsg({ elem: document.body, params: { action: 'againDrawMoney', clickid: '5.19' } })
        } else { // 提现失败 提示错误信息
          this.$toast({
            message: res.message,
            duration: 1500
          })
        }
      })
    },
    // 重新输入实名信息
    changeDrawMoney () {
      this.realname = ''
      this.realShow = false
      this.withDrawDialog = true
      this.userCash.authIdentity = 0
      this.$xesLogger.clickMsg({ elem: document.body, params: { action: 'changeDrawMoney', clickid: '5.8' } })
    },
    // 一分钟了解提现流程
    goWithdraw () {
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: { action: 'goWithdraw', clickid: '5.9' }
      })
      this.$router.push({ name: 'withdraw' })
    },
    cardChange () {
      const cardReg = /(^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)|(^(?=.*?[A-Za-z])(?=.*?[0-9]).{8}$)/
      if (cardReg.test(this.cardId)) {
        this.$xesLogger.clickMsg({
          elem: document.body,
          params: { action: 'cardInput', clickid: '5.10' }
        })
      }
    },
    // 展示提现规则弹窗
    discountToastShow () {
      this.discountShow = true
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: { action: 'discountToastShow', clickid: '5.7.1' }
      })
    },
    // 关闭提现规则弹窗
    discountToastClose () {
      this.discountShow = false
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: { action: 'discountToastClose', clickid: '5.16' }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.rewardPage {
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  padding: 8vw 4vw 0;
  font-family: PingFang SC Regular, PingFang SC Regular-Regular;
  background: #f5f7fb url('../assets/images/bg-rewardpage.png') no-repeat;
  background-size: 100%;

  &.rewardPage-notice {
    margin-top: 40px;
  }

  .rewardPage-reward-myown {
    text-align: left;
    background: #fff;
    border-radius: 2.133vw;

    .rewardPage-card-title {
      padding: 10px 16px;
      font-size: 13px;
      text-align: left;

      .icon-wallet {
        top: 3px;
        background-image: url('../assets/images/wallet.png');
      }

      .icon-gift {
        top: 3px;
        background-image: url('../assets/images/gift.png');
      }

      .icon-wenhao {
        top: 0;
        width: 10px;
        height: 10px;
        margin-left: 5px;
        background-image: url('../assets/images/wenhao.png');
      }

      p {
        display: inline;
        font-weight: 600;
        line-height: 20px;
      }
      // 查看明细
      .right {
        float: right;
        font-weight: 400;
        color: #f13f3f;
      }
    }

    .rewardPage-card-content {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 14px 16px;

      .rewardPage-card-item {
        text-align: center;
        color: #666;
        // 奖励金币，学费 数字
        .rewardPage-card-item-con {
          font-size: 12px;

          output {
            font-size: 21px;
            font-weight: 600;
            line-height: 27px;
            color: #f83f53;
          }
        }
        // 奖励描述信息
        .rewardPage-card-item-des {
          font-size: 11px;
          font-weight: 300;
        }

        &.link {
          .rewardPage-card-item-des {
            font-weight: 400;
            color: #207eff;
          }
        }
      }
    }

    .rewardPage-card-cash {
      padding: 14px 16px;

      .rewardPage-withdraw-count {
        output {
          font-size: 21px;
          color: #f83f53;
        }
      }

      .rewardPage-withdraw-count-empty {
        .rewardPage-withdraw-count-btn {
          background: #bfbfbf;
          cursor: not-allowed;
        }
      }

      .rewardPage-withdraw-count-btn {
        display: inline-block;
        width: 83px;
        margin-left: 26px;
        margin-bottom: 10px;
        font-size: 13px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        background: #f83f53;
        border-radius: 13px;
      }

      .rewardPage-withdraw-tip {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        font-weight: 300;
        line-height: 15px;
        color: #979797;

        & > p {
          flex: 1;
          line-height: 1.6;
        }
      }
    }

    & > div:nth-child(3) {
      padding-top: 16px;
      border-top: 1px dashed #f1d09d;
    }
  }

  .rewardPage-reward-extra,
  .rewardPage-reward-recomment {
    margin-top: 32px;
    background: #fff;

    .rewardPage-module-header {
      padding-left: 25px;
      margin-top: 17px;
      font-size: 17px;
      font-weight: 400;
      font-family: 'FZLanTingHeiS-DB-GB Regular', 'FZLanTingHeiS-DB-GB Regular-Regular';
      text-align: left;

      & > div {
        position: relative;

        &::before {
          position: absolute;
          top: 50%;
          left: -10px;
          width: 7px;
          height: 17px;
          // height: 100%;
          background: #f13f3f;
          border-radius: 4px;
          transform: translateY(-50%);
          content: '';
        }
      }
    }

    .rewardPage-module-main {
      width: 344px;
      padding: 30px 16px 24px; // v3.2 3个圈变4个圈
      border-radius: 0 0 8px 8px;

      .rewardPage-module-summary {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 19px;
        text-align: center;
        // 每个/项 总结
        & > div {
          flex: 1;
          width: 0;
          // 数量统计
          & > div {
            font-size: 15px;
            font-weight: 400;
            color: #f83f53;

            & > output {
              margin-right: 4px;
              font-size: 21px;
              font-weight: 600;
            }
          }
          // 描述信息
          & > p {
            overflow: hidden;
            font-size: 11px;
            font-weight: 300;
            white-space: nowrap;
            color: #2c3e50;
            text-overflow: ellipsis;
          }
        }
      }

      .rewardPage-module-content {
        max-height: 60vh;
        overflow: auto;
        background: #fff8e6;
        background: #f5f7fb;

        .rewardPage-module-list {
          padding: 15px 0;
          overflow: hidden;
          font-size: 12px;
          color: #1e1e1e;
          border-radius: 4px;// item 撑开高度消失
          .rewardPage-module-item {
            margin-bottom: 13px;

            .rewardPage-reward-recomment-user {
              font-weight: 400;
              color: #666;
            }
            // 注册，购课，结课
            .rewardPage-reward-recomment-items {
              display: flex;
              margin-top: 10px;
              text-align: center;

              & > div {
                flex: 25% 0;

                &:not(:last-child) {
                  & > div {
                    position: relative;

                    &::after {
                      position: absolute;
                      top: 50%;
                      left: 128%;
                      width: 17px;
                      height: 8px;
                      background: url('../assets/images/arrow-tri-right.png') no-repeat;
                      background-size: 100%;
                      transform: translateY(-50%);
                      content: '';
                    }
                  }
                }

                &.rewardPage-reward-recomment-item-gray {
                  & > div {
                    background: #dca6ac;
                  }
                }

                & > div { // 圆圈
                  width: 37px;
                  height: 37px;
                  margin: 0 auto;
                  line-height: 37px;
                  color: #fff;
                  background: #f83f53;
                  border-radius: 50%;
                }

                & > h5 { // 日期
                  min-height: 15px;
                  // margin: 4px 0;
                  margin-top: 4px;
                  font-size: 9px;
                  color: #f83f53;
                }

                & > p { // 描述信息
                  // height: 14px;
                  overflow: hidden;
                  font-size: 11px;
                  font-weight: 400;
                }
              }
            }
          }

          .rewardPage-module-loadmore {
            .nothingdata {
              color: #9b9b9b;
            }
            // 加载更多
            .showlangdata {
              font-weight: 400;
            }
          }
        }

        .rewardPage-module-none {
          padding: 21px 0 17px;
          font-size: 12px;
          font-weight: 400;
          color: #9b9b9b;
          background: #fff;

          & > div {
            width: 216px;
            height: 31px;
            margin: 14px auto 0;
            font-size: 13px;
            line-height: 31px;
            color: #fff;
            background: linear-gradient(#fc485c 0%, #e9263a 98%);
            border-radius: 16px;
          }
        }
      }

      .rewardPage-module-btn {
        margin-top: 16px; // 收起的话和summary 的margin-botton 重叠
        font-size: 12px;
        font-weight: 400;
        color: #f83f53;

        .icon {
          margin-left: 9px;

          &.icon-arrow-top {
            top: -2px;
            width: 10px;
            height: 6px;
            background-image: url('../assets/images/arrow-to-top.png');
            background-size: 100%;
          }

          &.icon-arrow-bottom {
            top: -2px;
            width: 10px;
            height: 6px;
            background-image: url('../assets/images/arrow-to-bottom.png');
            background-size: 100%;
          }
        }
      }
    }
  }

  .withDraw-details {
    .rewardPage-popup {
      width: 320px;
      height: 60vh;
      min-height: 200px;
      padding: 0 27px;
      background: linear-gradient(#fffff7 24%, #fff6df 99%) !important;
      border: 3px solid #fff;
      border-radius: 24px;
      box-shadow: 0 0 27px 0 rgba(231, 173, 83, 0.79) inset;

      &.van-popup {
        background-color: unset;
      }
      // 礼品卡说明弹窗
      &.giftcard-popup {
        height: 50vh;
      }

      .rewardPage-popup-close {
        position: absolute;
        top: 16px;
        right: 23px;
        width: 14px;
        height: 14px;
        background: url('../assets/images/tanchuang-close.png') no-repeat;
        background-size: 100%;
      }

      .rewardPage-popup-title {
        padding: 21px 0 11px;
        font-size: 24px;
        font-weight: 800;
        font-family: 'Lantinghei SC Heavy', 'Lantinghei SC Heavy-Heavy';
        line-height: 27px;
        color: #e02727;
        border-bottom: 1px dashed #cf6716;
        letter-spacing: 5px;
        text-shadow: 1px 0 0 #fff8ac;
      }

      .rewardPage-popup-content {
        position: absolute;
        top: 76px;
        bottom: 30px;
        left: 27px;
        right: 19px;
        overflow: auto;
        text-align: left;

        .withDraw-explain {
          min-height: 60px;
          overflow-y: auto;
          font-size: 11px;
          font-weight: 500;
          line-height: 22px;
          color: #3b69b8;

          i {
            color: #ff5b2f;
          }

          .withDraw-note-txt {
            font-size: 10px;
            color: #666;
          }
        }
      }
    }
    // 提现弹窗
    .van-popup {
      max-width: 300px;
      overflow: visible;
      color: #666;
      background: transparent;
      //  van-overlay
      .withDraw-idCard-dialog {
        width: 295px;
        padding-top: 16px;
        overflow: hidden;
        background: linear-gradient(0deg, rgba(252, 68, 64, 1) 0%, rgba(255, 135, 100, 1) 100%);
        border-radius: 8px;

        .withDraw-idCard-dialog__hd {
          position: relative;
          width: 255px;
          height: 89px;
          margin: 0 auto;
          text-align: center;
          background: url('../assets/images/card_bg.jpg') no-repeat;
          background-size: 100%;
          box-shadow: 0 0 17px 1px rgba(254, 46, 37, 0.45);

          .close {
            position: absolute;
            top: -10px;
            right: -10px;
            display: block;
            width: 14px;
            height: 14px;
            background: url('../assets/images/card_close.png') no-repeat;
            background-size: contain;
          }

          .withDraw-idCard-dialog__title {
            padding-bottom: 0;
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            text-align: center;
            color: #fff;

            span {
              font-weight: bold;
            }
          }

          .withDraw-idCard-dialog__nav {
            height: 89px;
            padding-bottom: 0;
            font-size: 18px;
            font-weight: bold;
            line-height: 90px;
            text-align: center;
            color: #ff3f2a;

            i {
              height: 14px;
              margin-top: 10px;
              font-size: 60px;
              background-image: none;
            }
          }

          .withDraw-idCard-dialog__navnew {
            line-height: 92px;
          }

          .withDraw-idCard-dialog__subtitle {
            padding-bottom: 5px;
            margin-top: -5px;
            text-align: center;
            color: #fff;
          }

          .detwithDraw-idCardails-dialog__obttitle {
            padding-bottom: 5px;
            line-height: 20px;
            text-align: center;
            color: #fff;
          }
        }

        .withDraw-idCard-imgBox {
          flex: 1;

          img {
            width: 46px;
            height: 46px;
            margin-left: 10px;
            border-radius: 50%;
          }
        }

        .withDraw-idCard-dialog__bd {
          min-height: 40px;
          padding: 10px 20px 10px;
          text-align: left;

          h2 {
            padding-left: 15px;
            font-size: 18px;
            font-weight: bold;
            text-align: left;
          }

          .withDraw-idCard-input {
            width: 100%;
            height: 36px;
            padding: 10px;
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            background: #fd4c44;
            border-radius: 5px;
            opacity: 1 !important;

            &::-webkit-input-placeholder {
              font-size: 12px;
              color: #fff;
              opacity: 0.5;
            }
          }

          p {
            padding: 10px 10px 0;
            font-size: 10px;
            color: #ffe6c5;

            i {
              color: #ffba3e;
            }
          }

          .withDraw-idCard-note {
            height: 11px;
            padding: 0;
            margin-top: 32px;
            margin-bottom: 17px;
            line-height: 11px;
            text-align: center;
            color: #adb4be;
          }

          .withDraw-idCard-dialog__cell {
            display: flex;
            align-items: center;
            padding: 5px 10px 0;

            .withDraw-idCard-dialog__nickname {
              max-width: 170px;
              overflow: hidden;

              h4 {
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: rgba(255, 255, 255, 1);
              }

              h3 {
                margin-top: 5px;
                font-size: 14px;
                font-weight: bold;
                line-height: 26px;
                color: #ffe6c5;
              }
            }
          }

          .withDraw-idCard-dialog__statement {
            font-weight: 400;
            color: #ffe6c5;

            i {
              color: #ffba3e;
            }
          }

          .withDraw-idCard-dialog__list {
            li {
              &:first-child {
                padding-bottom: 10px;
              }

              h2 {
                padding: 0;
                font-size: 16px;
                font-weight: 400;

                i {
                  color: #fff;
                }
              }

              .showcarid {
                margin-bottom: 10px;
              }

              p {
                padding: 0 5px;
              }

              .withDraw-idCard-dialog__nickname {
                display: flex;
                align-items: center;
                padding-bottom: 5px;

                img {
                  width: 30px;
                  height: 30px;
                }
              }

              .withDraw-idCard-headPadding {
                font-size: 12px;
                line-height: 20px;
                color: #ffe6c5;
              }
            }
          }
        }

        .withDraw-idCard-dialog__ft {
          p {
            height: 30px;
            font-size: 11px;
            color: #fff;
            opacity: 0.7;

            a {
              color: #fff;
            }
          }

          .withDraw-idCard-dialog__opcity {
            height: 40px;
            margin-top: 15px;
            font-weight: 500;
            line-height: 40px;
            color: #ffedd0;
            background: transparent;
            border: 1px solid rgba(255, 230, 197, 1);
            box-shadow: none;
          }
        }
      }

      .withDraw-idCard-realSure {
        padding-bottom: 20px;
        border-radius: 5px;
      }
    }

    .withDraw-idCard-dialog-conne {
      width: 295px;
      height: 201px;
      background: url('../assets/images/rewardpage-liucheng.png') no-repeat;
      background-size: 100% 100%;

      .withDraw-idCard-dialog-close {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 50px;
        height: 50px;
        background: url('../assets/images/reward-close.png') no-repeat;
        background-size: 100% 100%;
      }

      .withDraw-idCard-dialog__ft {
        position: absolute;
        bottom: 30px;
        left: 50%;
        width: 197px;
        height: 44px;
        background: url('../assets/images/reward-liucheng-btn.png') no-repeat;
        background-size: cover;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
